module.exports = __webpack_public_path__ + "media/images/landing/animations/animace-influenceri-97ea44c06d13545d7fe94e554bf71020.mp4";